import { apiRequest } from '@nusrif/utils';
import { GenerateOtpParams, GenerateOtpResponse, VerifyOtpParams, VerifyOtpResponse } from '@nusrif/types';
import { removeUser } from './user-services';
import { getTrackingId } from './tracking-services';

export async function generateOtp(params: GenerateOtpParams): Promise<GenerateOtpResponse> {
  return apiRequest<GenerateOtpResponse>('/otp/generate', {
    method: 'POST',
    body: params,
  });
}

export async function verifyOtp(params: VerifyOtpParams): Promise<VerifyOtpResponse> {
  return apiRequest<VerifyOtpResponse>('/otp/verify', {
    method: 'POST',
    body: {
      ...params,
      distincId: getTrackingId(),
    },
  });
}

// Token-based authentication using localStorage
export function setToken(token: string) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('token', token);
  }
}

export function getToken(): string | null {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('token');
  }
  return null;
}

export function removeToken() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('token');
  }
}

export function isAuthenticated(): boolean {
  return !!getToken();
}

export function logout() {
  removeToken();
  removeUser();

  // Clear local stroage 
  localStorage.clear();
  sessionStorage.clear();
}